<template>
  <div class="hmt-carousel-container">
    <div class="hmt-carousel__nav" v-if="!isMobile()">
      <button class="hmt-carousel__nav-button hmt-carousel__nav-button--prev">
        <FontAwesomeIcon icon="chevron-left" />
      </button>
      <button class="hmt-carousel__nav-button hmt-carousel__nav-button--next">
        <FontAwesomeIcon icon="chevron-right" />
      </button>
    </div>
    <swiper 
      :options="swiperOption"
      class="hmt-carousel"
      @clickSlide="selectPhoto"
    >
      <swiper-slide
        v-for="photo in items"
        :key="photo.md"
      >
        <HMTImageWatermark
          v-if="getUnpaid" 
          :src="photo.md" 
        />
        <lazy-image 
          v-else 
          :src="photo.md" 
        />
        <span class="swiper-slide__icon">
          <FontAwesomeIcon icon="search" />
        </span>
        <div class="swiper-lazy-preloader swiper-lazy-preloader-black"></div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  import HMTImageWatermark from '@/shared/components/ImageWatermark';
  import deviceMixin from '@/shared/mixins/device';

  export default {
    name: 'Carousel',
    mixins: [
      deviceMixin
    ],
    components: {
      HMTImageWatermark
    },
    props: {
			items: {
				type: Array
			}
		},
    data() {
      return {
        swiperOption: {
          slidesPerView: 'auto',
          slidesPerColumn: 1,
          slidesPerColumnFill: 'row',
          spaceBetween: 15,
          breakpoints: {
            780: {
              slidesPerColumn: 2,
              spaceBetween: 25
            }
          },
          navigation: {
            nextEl: '.hmt-carousel__nav-button--next',
            prevEl: '.hmt-carousel__nav-button--prev',
          }
        }
      }
    },
    computed: {
      ...mapGetters('tour', ['getUnpaid'])
    },
    methods: {
      selectPhoto (photoIndex) {
        this.$emit('onSelectItem', photoIndex);
      }
    }
  };
</script>

<style lang="scss">
  .hmt-carousel {
    &-container {
      position: relative;
    }

    &__nav {
      &-button {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        z-index: 15;
        width: 38px;
        height: 48px;
        border: 2px solid #ffd800;
        background-color: transparent;
        cursor: pointer;
        transition: background-color .2s ease-out;
        outline: none;

        &:hover:not([aria-disabled="true"]) {
          background: rgba(#ffd800, .15);
        }

        &[aria-disabled="true"] {
          cursor: default;
        }

        &--next {
          right: -20px;
          border-top-right-radius: 4px;
          border-bottom-right-radius: 4px;

          @media only screen and (min-width: 1340px) {
            right: -55px;
          }
        }
        &--prev {
          left: -20px;
          border-top-left-radius: 4px;
          border-bottom-left-radius: 4px;

          @media only screen and (min-width: 1340px) {
            left: -55px;
          }
        }
      }
    }

    .swiper-slide {
      $slide: &;

      position: relative;
      width: 240px;
      height: 300px;
      cursor: pointer;

      &:hover {
        &:before { 
          opacity: 1;
        }

        .swiper-slide__icon {
          opacity: 1;
          transform: translate(-50%, -50%);
        }
      }

      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        z-index: 35;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,.8);
        opacity: 0;
        transition: opacity .2s ease-out;
      }

      img {
        position: relative;
        z-index: 30;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      &__icon {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: 40;
        transform: translate(-50%, 50%);
        width: 46px;
        height: 46px;
        background-color: transparent;
        border: 2px solid #ffd800;
        border-radius: 50%;
        opacity: 0;
        transition: opacity .2s ease-out, transform .25s ease-out .05s;

        .fa-search {
          position: relative;
          z-index: 1;
          color: #fff;
        }
      }
    }
  }
</style>
